import { useMutation, useQueryClient } from '@tanstack/react-query';
import { services } from '../../../lib/api/services/index';

import { UserSettingsResponse, UserSettingsUpdateInput } from '@repo/types';
import { useQueryWithConfig } from '../useQueryWithConfig';

// Hook for fetching user settings
export const useUserSettings = () => {
  // #region agent log

  // #endregion
  const result = useQueryWithConfig<UserSettingsResponse>(
    ["user-settings"],
    () => services.userSettings.getUserSettings()
  );
  // #region agent log

  // #endregion
  return result;
};

// Hooks for user settings mutations
export const useCreateUserSettings = () => {
  const queryClient = useQueryClient();

  return useMutation<UserSettingsResponse, Error, UserSettingsUpdateInput>({
    mutationFn: (data) => services.userSettings.createUserSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-settings"] });
    },
  });
};

export const useUpdateUserSettings = () => {
  const queryClient = useQueryClient();

  return useMutation<UserSettingsResponse, Error, UserSettingsUpdateInput>({
    mutationFn: (data) => services.userSettings.updateUserSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-settings"] });
    },
  });
};

export const useDeleteUserSettings = () => {
  const queryClient = useQueryClient();

  return useMutation<{ message: string }, Error, void>({
    mutationFn: () => services.userSettings.deleteUserSettings(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-settings"] });
    },
  });
};
